// i18n
import i18n from "i18next";
import setAuthToken from "config/setAuthToken";
import { toast } from "react-toastify";
import { auth, db, getHeaders } from "../config/firebase";
import { LOAD_USER, LOGOUT, LOGIN } from "./types";
import { URL } from "../config/config";
// API endpoint
export const API_ENDPOINT = URL.API_URL;
export const login = (email, password) => async (dispatch) => {
  const trimmedEmail = email.toLowerCase().trim();
  let passwordCorrect = false;
  try {
    // Step 1: Check credentials
    await auth.signInWithEmailAndPassword(trimmedEmail, password);
    passwordCorrect = true;
  } catch (err) {
    toast.error(i18n.t("auth.login.incorrectCredentials"));
    return;
  }
  // Step 2: Check password strength
  const emailParts = trimmedEmail.split(/[@.]/);
  const lengthValid = password.length >= 12;
  const upperValid = /[A-Z]/.test(password);
  const lowerValid = /[a-z]/.test(password);
  const digitValid = /\d/.test(password);
  const specialValid = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  let affinityValidLocal = true;
  for (const part of emailParts) {
    if (part.length >= 3 && password.toLowerCase().includes(part)) {
      affinityValidLocal = false;
      break;
    }
  }
  const passwordStrong =
    lengthValid && upperValid && lowerValid && digitValid && specialValid && affinityValidLocal;
  // Step 3: Handle login based on both conditions
  if (passwordCorrect && !passwordStrong) {
    try {
      const link = await sentResetLink(trimmedEmail, password, "vbs");
      toast.warning(i18n.t("auth.login.weakPassword"));
      setTimeout(() => (window.location.href = link), 300);
    } catch (err) {
      toast.error(i18n.t("auth.login.resetFailed"));
    }
    return;
  }
  if (passwordCorrect && passwordStrong) {
    const userSnapshot = await db.collection("users").where("email", "==", trimmedEmail).get();
    const user = userSnapshot.docs[0].data();
    const { roles } = user;

    if (roles.includes("managerVBS") || roles.includes("adminVBS")) {
      const token = await getHeaders();
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token.Authorization);
      dispatch({ type: LOGIN, payload: user });
      toast.success(i18n.t("auth.login.success"));
    } else {
      toast.error(i18n.t("auth.login.notAllowed"));
    }
  }
};
export const sendResetPassword = async (name, email, app) => {
  const requestBody = { name, email, app };
  try {
    const res = await fetch(`${API_ENDPOINT}/SendResetPassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    if (res.status === 200) {
      const data = await res.json();
      return data.link;
    } else {
      const text = (JSON.parse(await res.text()).error) || "Unknown error"
      throw new Error(text || i18n.t("auth.reset.failed"));
    }
  } catch (err) {
    throw new Error(err.message || i18n.t("auth.reset.networkError"));
  }
};
export const sentResetLink = async (email, password, app) => {
  try {
    // Trim and validate email
    const trimmedEmail = email.trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
    if (!isValidEmail) throw new Error(i18n.t("auth.reset.invalidEmail"));
    // Sign in the user first
    const userCredential = await auth.signInWithEmailAndPassword(
      email,
      password
    );
    const user = userCredential.user;
    // Get fresh Firebase ID token
    const idToken = await user.getIdToken(true);
    // Call backend
    const res = await fetch(`${API_ENDPOINT}/sentResetLink`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: idToken, // raw token like Angular example
      },
      body: JSON.stringify({ userEmail: trimmedEmail, app }),
    });
    if (!res.ok) {
      const text = (JSON.parse(await res.text()).error) || "Unknown error"
      throw new Error(text || i18n.t("auth.reset.failed"));
    }
    const data = await res.json();
    return data.link;
  } catch (err) {
    throw new Error(err.message || i18n.t("auth.reset.failed"));
  }
};
export const logout = () => (dispatch) => {
  try {
    dispatch({
      type: LOGOUT,
    });
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return auth.signOut();
  } catch (error) {
    console.log(error);
  }
};
export const loadUser = () => async (dispatch) => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  let user = JSON.parse(localStorage.getItem("user"));
  dispatch({
    type: LOAD_USER,
    payload: user,
  });
};
